import { EventBus, EnumEventBus } from "./EventBus";
import Grid from "../entities/grid/Grid";
import { testGridData2 } from "../types/Config";
import { ButtonStatus } from "../types/Enum";


export default class GridDataManager {
  Grid: Grid;
  EventBus = EventBus;
  games: number[][] = [];
  currGameIndex: number = 0;
  currTestIndex: number = -1;
  isAutoPlay: boolean;
  isBonus: boolean = false;
  constructor() {
    this.Grid = new Grid(testGridData2[0][0]);

    this.EventBus.on(EnumEventBus.spin, (b: string) => this.handleSpin(Boolean(b)));
    this.EventBus.on(EnumEventBus.gameIsCompleted, () => this.handleGameCompleted());
  }
  handleGameCompleted() {
    if (this.games.length > this.currGameIndex + 1) {
      this.currGameIndex++;
      this.isBonus = true;

      this.EventBus.emit(EnumEventBus.setBonusGame, true);
      if (this.isAutoPlay) {
        setTimeout(() => {
          this.runGame();
        }, 1000);
        return
      }
      this.EventBus.emit(EnumEventBus.setBPlayButStatus, ButtonStatus.show);
      this.EventBus.emit(EnumEventBus.setPlayButStatus, ButtonStatus.hide);
      return
    }

    this.games = [];
    this.currGameIndex = 0;
    this.isBonus = false;

    if (this.isAutoPlay) {
      this.EventBus.emit(EnumEventBus.setBonusGame, false);
      return this.EventBus.emit(EnumEventBus.autoGameIsCompleted);
    }
    this.EventBus.emit(EnumEventBus.setBPlayButStatus, ButtonStatus.hide);
    this.EventBus.emit(EnumEventBus.setPlayButStatus, ButtonStatus.show);
    this.EventBus.emit(EnumEventBus.setAPlayButStatus, ButtonStatus.show);
    this.EventBus.emit(EnumEventBus.setBonusGame, false);
  }
  checkGames() {
    if (this.isBonus) {
      return this.runGame()
    }
    const games = this.sendRequest();
    this.handleGamesData(games);
  }
  handleSpin(isAutoPlay: boolean) {
    this.isAutoPlay = isAutoPlay;
    this.checkGames();
  }
  sendRequest() {
    //send request 

    this.currTestIndex++;
    const currTestIndex = this.currTestIndex % testGridData2.length;
    return testGridData2[currTestIndex];
  }
  runGame() {
    this.Grid.runGridAnimation(this.games[this.currGameIndex], this.isAutoPlay);
  }
  handleGamesData(games: number[][]) {
    this.games = games;
    this.runGame();
  }
}